import { configureStore } from '@reduxjs/toolkit'
import {errorReducer , severityReducer , userReducer} from '../features/error/slices'
export default configureStore({
  reducer: {
    error: errorReducer,
    severity: severityReducer,
    user:userReducer,
  }
})